export default "__VITE_ASSET__CQ4WIqMH__"